module.exports = __webpack_public_path__ + "img/11-low.195d85b2.jpg";